import http from "@/utils/http";


export const NexusDeviceApi = {
	//获取简单列表（全部规则）
	querySimpleList() {
		return http.get(`/nexus/device/querySimpleList`)
	},
	page(query) {
		return http.get(`/nexus/device/page`,query)
	},
}